import JWTinterceptor from "@/services/axios";


export async function getProfileDataService(token){
    try{
         const response = await JWTinterceptor.get(`profile`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-access-tokens': token
            }
        });
        return response.data;
    }catch(err){
        console.error("Get profile data error:", err);
        throw err;
    }
}
export async function updateProfileDataService(payload,token){
    try{
        const response = await JWTinterceptor.post(`profile_update`, { payload}, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-tokens': token
        }
        });
        return response.data
    }catch(err){
        console.error("Update profile data error:", err);
        throw err;
    }
}